import SkeletonLoader from './index';

const TABLE_ROWS = [1, 2, 3, 4];

const SubscriptionSkeleton = () => (
  <div className="max-w-216 w-full space-y-6">
    <SkeletonLoader width={180} height={28} />

    <div className="border border-neutral-light-200 rounded-xl p-6 space-y-4">
      <div className="flex items-start justify-between">
        <div className="space-y-2">
          <SkeletonLoader width={120} height={20} />
          <SkeletonLoader width={220} height={32} />
        </div>
        <SkeletonLoader width={140} height={40} className="rounded-lg" />
      </div>
      <div className="flex gap-10">
        <SkeletonLoader width={100} height={20} />
        <SkeletonLoader width={140} height={20} />
        <SkeletonLoader width={120} height={20} />
      </div>
      <SkeletonLoader width="100%" height={48} className="rounded-lg" />
    </div>

    <div className="border border-neutral-light-200 rounded-2xl p-6 space-y-3">
      <div className="flex items-center justify-between">
        <SkeletonLoader width={160} height={24} />
        <SkeletonLoader width={120} height={36} className="rounded-lg" />
      </div>
      {TABLE_ROWS.map((i) => (
        <SkeletonLoader key={i} width="100%" height={48} />
      ))}
    </div>

    <div className="border border-neutral-light-200 rounded-xl p-6 flex items-center justify-between">
      <div className="space-y-2">
        <SkeletonLoader width={180} height={20} />
        <SkeletonLoader width={260} height={16} />
      </div>
      <SkeletonLoader width={170} height={40} className="rounded-lg" />
    </div>
  </div>
);

export default SubscriptionSkeleton;
